export default __webpack_public_path__ + "static/media/3M.7017d883.png";